'use client';

import { AuthProvider } from '@/contexts/AuthContext';
import { RouterStateContextProvider } from '@/contexts/RouterStateContext';
import { useAnalyticsUserProperty } from '@/hooks/useAnalyticsUserProperty';
import { SafeNavigatorProvider } from '@/modules/SafeNavigator';
import { User } from 'callabo-api/src';
import { useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useFetchCallaboSettings } from './settings/useSettingsStore';
import { FirebaseStoreInitializer } from './FirebaseStore';

export const App = ({ children, me }: { children: React.ReactNode; me: User }) => {
  const [queryClient] = useState(() => new QueryClient());

  useFetchCallaboSettings();

  return (
    <SafeNavigatorProvider>
      <FirebaseStoreInitializer />
      <QueryClientProvider client={queryClient}>
        <AuthProvider me={me}>
          <RouterStateContextProvider>
            <WithAnalytics>{children}</WithAnalytics>
          </RouterStateContextProvider>
        </AuthProvider>
      </QueryClientProvider>
    </SafeNavigatorProvider>
  );
};

function WithAnalytics({ children }: { children?: React.ReactNode }): JSX.Element {
  useAnalyticsUserProperty();
  return <>{children}</>;
}
